import { render, staticRenderFns } from "./completions-item-category.vue?vue&type=template&id=379cb4e8&"
import script from "./completions-item-category.vue?vue&type=script&lang=js&"
export * from "./completions-item-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports